import { login } from '@redux/auth/authSlice';
import {
  Button, Form, Input
} from 'antd';
import Link from 'next/link';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { analytics } from '@lib/analytics';
import style from './login-form.module.scss';

const mapStatesToProps = (state: any) => ({
  loginAuth: { ...state.auth.loginAuth },
  siteName: state.ui.siteName
});

const mapDispatchToProps = {
  handleLogin: login
};

const connector = connect(mapStatesToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

function LoginForm({
  loginAuth,
  siteName,
  handleLogin
}: PropsFromRedux) {
  const router = useRouter();
  const requireEmailVerification = useSelector(
    (state: any) => state.settings.requireEmailVerification
  );

  return (
    <div className={style['login-form']}>
      <p className={style.subtitle}>
        Log in to unlock creativity, connection, and meaningful support
      </p>

      <Form
        name="normal_login"
        initialValues={{ remember: true }}
        onFinish={(v) => {
          analytics.login('email');
          handleLogin({ ...v, redirect: router?.query?.redirect || '' });
        }}
        style={{ boxSizing: 'border-box', width: '100%' }}
      >
        <Form.Item
          name="username"
          validateTrigger={['onChange', 'onBlur']}
          rules={[{ required: true, message: 'Email/Username is required' }]}
          style={{ paddingBottom: '16px' }}
        >
          <Input
            disabled={loginAuth.requesting}
            placeholder="Email or Username"
            size="large"
          />
        </Form.Item>

        <Form.Item
          name="password"
          validateTrigger={['onChange', 'onBlur']}
          rules={[{ required: true, message: 'Password is required' }]}
        >
          <Input.Password
            disabled={loginAuth.requesting}
            placeholder="Password"
            size="large"
          />
        </Form.Item>

        <div className={style['forgot-password-verification']}>
          <Link href="/auth/forgot-password" className={style['sub-text']}>
            Forgot password?
          </Link>
          {requireEmailVerification && (
            <Link href="/auth/resend-email" className={style['sub-text']}>
              Resend verification
            </Link>
          )}
        </div>

        <Button
          disabled={loginAuth.requesting}
          loading={loginAuth.requesting}
          type="primary"
          htmlType="submit"
          className={style['form-button']}
          size="large"
        >
          Log In
        </Button>
      </Form>

      {/* Divider */}
      <div className={style['divider-row']}>
        <span className={style['divider-line']} />
        <span className={style['divider-text']}>or</span>
        <span className={style['divider-line']} />
      </div>

      <Button
        disabled={loginAuth.requesting}
        loading={loginAuth.requesting}
        href="/auth/register"
        className={style['form-button-pink']}
        size="large"
      >
        Sign Up
      </Button>

      <p className={style['terms-text']}>
        By signing up, you agree to our
        {' '}
        <Link href="/page/terms-of-service">Terms of Service</Link>
        {' '}
        and
        {' '}
        <Link href="/page/privacy-policy">Privacy Policy</Link>
      </p>
    </div>
  );
}

export default connector(LoginForm);
